import { isInTelegram } from '../lib/telegram';

/**
 * Telegram's MainButton is native chrome, not a DOM element — it simply doesn't render when the
 * Mini App is opened in a plain browser (e.g. during local dev/testing outside Telegram). This
 * renders an on-page equivalent in that case only, so the flow is never silently un-completable.
 */
export default function MainButtonFallback({
  text,
  onClick,
  disabled,
  loading,
}: {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
}) {
  if (isInTelegram()) return null;

  return (
    <div className="fixed inset-x-0 bottom-16 z-40 flex justify-center px-4">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        className="w-full max-w-md rounded-full bg-mlbb-accent py-3 text-sm font-medium text-white shadow-lg disabled:opacity-40"
      >
        {loading ? '...' : text}
      </button>
    </div>
  );
}
